export interface ParcelExitReminderState {
  pickupPointName: string;
  pendingCount: number;
  visible: boolean;
}

export const idleParcelExitReminder: ParcelExitReminderState = {
  pickupPointName: "",
  pendingCount: 0,
  visible: false
};

export function createParcelExitReminder({
  pendingCount,
  pickupPointName
}: {
  pendingCount: number;
  pickupPointName: string;
}): ParcelExitReminderState {
  return {
    pendingCount: Math.max(1, pendingCount),
    pickupPointName,
    visible: true
  };
}
